import { createContext, useContext } from 'react';

type ChatMessageContextValue = {
  side: 'left' | 'right';
  isLast: boolean;
};

const ChatMessageContext = createContext<ChatMessageContextValue | undefined>(undefined);

export const useChatMessageContext = () => {
  const context = useContext(ChatMessageContext);
  if (!context) {
    throw new Error('ChatMessage components must be used within ChatMessage');
  }
  return context;
};

export const ChatMessageProvider = ChatMessageContext.Provider;
